import Vue from 'vue';
import Vuex from 'vuex';

import { alert } from './alert.module';
import { account } from './account.module';
import { users } from './users.module';
import { pravicePridelava } from './pravicePridelava.module';
import { sifrant } from './sifrant.module';
import { pravicePredelava } from './pravicePredelava.module';
import { pridelava } from './pridelava.module';
import { gerk } from './gerk.module';
import { kmrs } from './kmrs.module';
import { gerkHistory } from './gerkHistory.module';
import { kultura } from './kultura.module';
import { zival } from './zival.module';
import { proizvod } from './proizvod.module';
import { kontrola } from './kontrola.module';
import { odlocba } from './odlocba.module';
import { certifikat } from './certifikat.module';

import { predelava } from './predelava.module';
import { dejavnost } from './dejavnost.module';
import { dislociranaenota } from './dislociranaenota.module';
import { kontrolaPredelava } from './kontrolaPredelava.module';

import { certifikatPredelava } from './certifikatPredelava.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        alert,
        account,
        users,
        sifrant,
        pravicePridelava,
        pravicePredelava,
        pridelava,
        gerk,
        gerkHistory,
        kmrs,
        kultura,
        zival,
        proizvod,
        kontrola,
        odlocba,
        certifikat,
        predelava,
        dejavnost,
        dislociranaenota,
        kontrolaPredelava,
        certifikatPredelava
    }
});
